import { Injectable } from '@angular/core';
import { translations } from 'src/app/i18n/translations';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private lang = navigator.language.substring(0, 2).toLowerCase();

  constructor(appService: AppService) {
    appService.userProfileSubject.subscribe(profile => {
      const raw = profile?.language || profile?.locale || navigator.language;
      this.lang = raw.substring(0, 2).toLowerCase();
    });
  }

  get(key: string): string {
    return translations[this.lang]?.[key] ?? translations['en']?.[key] ?? key;
  }
}
